import { tap } from 'rxjs/operators';

import log from './log';

export default function flog(label) {
  var map = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (x) {
    return x;
  };

  return function flogOperator(obs$) {
    return obs$.pipe(tap(log(label, map)));
  };
}